import {useGetDesignContexts} from "./useGetDesignContexts";
import {useGetMediaContexts} from "./useGetMediaContexts";
import {useGetHseDesignContexts} from "./useGetHseDesignContexts";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {AppTester} from "../../../../supporting";
import {useGetGalllleryContexts} from "./useGetGalllleryContexts";
import { useGetHseSpaceContext } from "./useGetHseSpaceContext";

export const useContextLinksNew = () => {

    const {
        isMediiia,
        isBooks,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isDeziiign,
        isHSEDesign,
        isAgeytomesh,
        isDvaDesign,
        isGalllleryArt,
        isOnlines,
        isSchool,
        isBrnd,
        isCGRAVE,
        isPortfolio365,
    } = useAppTester()

    const isHseColors = AppTester.isHseColors();
    const isBooksGallery = AppTester.isBooksGallllery();
    const isContinuumSite = AppTester.isContinuumSite();
    const isCompetitionDeziiign = AppTester.isCompetition()
    const isLMSHSECreative = AppTester.isLMSHSECreative()
    const isHseSpace = AppTester.isHseSpace();
    const isHseAnimation = AppTester.isHseAnimation();

    const designContexts = useGetDesignContexts()
    const mediaContexts = useGetMediaContexts()
    const hseDesignContexts = useGetHseDesignContexts()
    const galllleryContexts = useGetGalllleryContexts()
    const hseSpaceContexts = useGetHseSpaceContext();

    if (isAgeytomesh || isHseAnimation || isDvaDesign || isGalllleryArt || isBrnd || isContinuumSite || isOnlines || isSchool || isPortfolio365 || isLMSHSECreative) return {
        links: [],
        modalSettings: {
            title: '',
            titleColor: ''
        }
    }
    if (isBooksGallery) return galllleryContexts
    if (isHseSpace) return hseSpaceContexts
    if (isHSEDesign && !isHseColors) return hseDesignContexts
    if (isMediiia) return mediaContexts
    if ((isBooks || isFashionDeziiign || isGameDeziiign || isProDeziiign || isDeziiign || isCompetitionDeziiign) && !isCGRAVE) return designContexts
    return {
        links: <any[]>[],
        modalSettings: {
            title: '',
            titleColor: ''
        }
    }
}import {useGetDesignContexts} from "./useGetDesignContexts";
import {useGetMediaContexts} from "./useGetMediaContexts";
import {useGetHseDesignContexts} from "./useGetHseDesignContexts";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {AppTester} from "../../../../supporting";
import {useGetGalllleryContexts} from "./useGetGalllleryContexts";
import { useGetHseSpaceContext } from "./useGetHseSpaceContext";

export const useContextLinksNew = () => {

    const {
        isMediiia,
        isBooks,
        isFashionDeziiign,
        isGameDeziiign,
        isProDeziiign,
        isDeziiign,
        isHSEDesign,
        isAgeytomesh,
        isDvaDesign,
        isGalllleryArt,
        isOnlines,
        isSchool,
        isBrnd,
        isCGRAVE,
        isPortfolio365,
    } = useAppTester()

    const isHseColors = AppTester.isHseColors();
    const isBooksGallery = AppTester.isBooksGallllery();
    const isContinuumSite = AppTester.isContinuumSite();
    const isCompetitionDeziiign = AppTester.isCompetition()
    const isLMSHSECreative = AppTester.isLMSHSECreative()
    const isHseSpace = AppTester.isHseSpace();
    const isHseAnimation = AppTester.isHseAnimation();

    const designContexts = useGetDesignContexts()
    const mediaContexts = useGetMediaContexts()
    const hseDesignContexts = useGetHseDesignContexts()
    const galllleryContexts = useGetGalllleryContexts()
    const hseSpaceContexts = useGetHseSpaceContext();

    if (isAgeytomesh || isHseAnimation || isDvaDesign || isGalllleryArt || isBrnd || isContinuumSite || isOnlines || isSchool || isPortfolio365 || isLMSHSECreative) return {
        links: [],
        modalSettings: {
            title: '',
            titleColor: ''
        }
    }
    if (isBooksGallery) return galllleryContexts
    if (isHseSpace) return hseSpaceContexts
    if (isHSEDesign && !isHseColors) return hseDesignContexts
    if (isMediiia) return mediaContexts
    if ((isBooks || isFashionDeziiign || isGameDeziiign || isProDeziiign || isDeziiign || isCompetitionDeziiign) && !isCGRAVE) return designContexts
    return {
        links: <any[]>[],
        modalSettings: {
            title: '',
            titleColor: ''
        }
    }
}